import { getTokenConfig } from '../utils/networkUtils'

// Share message templates
export const SHARE_MESSAGES = {
  whatsApp: {
    upcoming: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Join ${name} game room on #PanenkaFC 🏆 worth ${prizePool} ${tokenLabel}
Its Free-to-Play! 
Create the ultimate lineup and win BIG in realtime!  

#WhereFansPlay
Game room link:  `,

    active: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Check out ${name} game room on #PanenkaFC worth ${prizePool} ${tokenLabel}
Compete with 1000+ fans for a chance to win BIG $$ in real-time! 🏆 

#WhereFansPlay
Game room link: `,
  },

  telegram: {
    upcoming: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Join ${name} game room on #PanenkaFC 🏆 worth ${prizePool} ${tokenLabel}
Its Free-to-Play! 
Create the ultimate lineup and win BIG in realtime!  

#WhereFansPlay
Check above link`,

    active: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Check out ${name} game room on #PanenkaFC worth ${prizePool} ${tokenLabel}
Compete with 1000+ fans for a chance to win BIG $$ in real-time! 🏆 

#WhereFansPlay
Check above link`,
  },

  twitter: {
    upcoming: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Join ${name} game room on #PanenkaFC 🏆 worth ${prizePool} ${tokenLabel}
Its Free-to-Play! 
Create the ultimate lineup and win BIG in realtime!  

#WhereFansPlay
Game room link:  `,

    active: (
      name,
      prizePool,
      tokenLabel
    ) => `Think you're a football mastermind? Prove it! 🧠 
Check out ${name} game room on #PanenkaFC worth ${prizePool} ${tokenLabel}
Compete with 1000+ fans for a chance to win BIG $$ in real-time! 🏆 

#WhereFansPlay
Game room link: `,
  },
}

// Helper functions
export const getTeamsData = (grDetails) => {
  if (!grDetails?.teams?.length) {
    return { firstTeam: null, secondTeam: null }
  }

  const location = grDetails.location || {}

  const firstTeam = grDetails.teams.find(({ id }) => id === location.home)

  const secondTeam = grDetails.teams.find(({ id }) => id === location.away)

  return { firstTeam, secondTeam }
}

//  UPDATED: now config-driven
export const getShareMessage = (
  platform,
  roomStatus,
  name,
  prizePool,
  token
) => {
  const isUpcoming = roomStatus === 'upComing' || roomStatus === 'entryOpened'

  const messageType = isUpcoming ? 'upcoming' : 'active'

  //  get token info from config
  const tokenConfig = getTokenConfig(token)

  const tokenLabel = tokenConfig?.network
    ? token // you can enhance later (symbol/format)
    : token // fallback safety

  return SHARE_MESSAGES[platform][messageType](name, prizePool, tokenLabel)
}
